import * as z from 'zod';
import { Ören } from '../base-schemas';
export const ReservableProductPricing = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('single_price'),
        price: Ören
    }),
    z.object({
        kind: z.literal('multiple_prices'),
        from_price: Ören
    }),
    z.object({
        kind: z.literal('unpriced')
    })
]);
